/* eslint-disable jira/filename-case */

import type {
	RouterContext,
	RouteResource,
	RouteWithResources,
	ResourceStoreContext,
} from '../../../../../common/types.tsx';
import {
	getResourceIdentifier,
	getResourceIdentifiers,
} from '../get-resource-identifier/getResourceIdentifier.tsx';
import { routeHasChanged, routeHasResources } from '../route-checks/routeHasResources.tsx';

/**
 * Gets the requestable resources for the next location.
 */
export const getResourcesForNextLocation = (
	prevRouterStoreContext: RouterContext,
	nextRouterStoreContext: RouterContext,
	resourceStoreContext: ResourceStoreContext,
): RouteResource[] => {
	const { route: prevRoute } = prevRouterStoreContext;
	const { resources: prevResources = [] } = (prevRoute as RouteWithResources) || {};
	const { route: nextRoute } = nextRouterStoreContext;
	const { resources: nextResources = [] } = (nextRoute as RouteWithResources) || {};

	if (!routeHasResources(nextRoute)) {
		return [];
	}

	if (routeHasChanged(prevRoute, nextRoute)) {
		return nextResources;
	}

	const prevResourceIdentifiers = getResourceIdentifiers(
		prevResources,
		prevRouterStoreContext,
		resourceStoreContext,
	);

	return nextResources.filter(
		(resource) =>
			!prevResourceIdentifiers.includes(
				getResourceIdentifier(resource, nextRouterStoreContext, resourceStoreContext),
			),
	);
};
